// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************

import { RequestSubscriptionChangeRequestInterface } from './api.interface';

export class RequestSubscriptionChangeRequest implements RequestSubscriptionChangeRequestInterface {
    businessId: string;
    message: string;
    phoneNumber: string;
    name: string;

    static fromProto(proto: any): RequestSubscriptionChangeRequest {
        let m = new RequestSubscriptionChangeRequest();
        m = Object.assign(m, proto);
        return m;
    }

    constructor(kwargs?: RequestSubscriptionChangeRequestInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
            typeof this.businessId === 'undefined' &&
            typeof this.message === 'undefined' &&
            typeof this.phoneNumber === 'undefined' &&
            typeof this.name === 'undefined') {
            return {};
        }

        const toReturn: {
            [key: string]: any;
        } = {};

        if (typeof this.businessId !== 'undefined') {toReturn.businessId = this.businessId;}
        if (typeof this.message !== 'undefined') {toReturn.message = this.message;}
        if (typeof this.phoneNumber !== 'undefined') {toReturn.phoneNumber = this.phoneNumber;}
        if (typeof this.name !== 'undefined') {toReturn.name = this.name;}
        return toReturn;
    }
}
